<ng-container *ngIf="variantOptionsToDisplay$ | async as variantOptionsToDisplay">

  <div *ngIf="(totalVariants$ | async) > 1" class="mb-product-choose-text" data-cy="mb-total-variants">
    <span [innerHTML]="'mbproduct.chooseProduct' | mbTranslate"></span>
  </div>

  <mb-pdp-product-filters *ngIf="(totalVariants$ | async) > 1; else addSpacing"></mb-pdp-product-filters>

  <ng-template #addSpacing>
    <div class="row no-gutters mt-4 mb-3"></div>
  </ng-template>

  <div *ngIf="variantOptionsToDisplay?.length > 0"
       class="mb-variants-list"
       data-cy="mb-variants-list">
    <div class="row no-gutters hidden-xs hidden-sm">
      <div class="pl-3 hidden-md"
           [ngClass]="[(dynamicColumnLabels$ | async)?.length > 1 ? 'mb-one-and-half-column-width' : 'col-2']">
        <strong [innerHTML]="'pdpProductLine.orderNumber' | mbTranslate"></strong>
      </div>
      <div class="pl-3" [ngClass]="[(hasDynamicColumns$ | async) ? 'col-md-3' : 'col-md-5 col-lg-3']">
        <strong [innerHTML]="'pdpProductLine.productName' | mbTranslate"></strong>
      </div>
      <ng-container *ngIf="hasDynamicColumns$ | async; else noDynamicColumns">
        <div *ngFor="let columnLabel of (dynamicColumnLabels$ | async)" class="col pl-3 mb-dynamic-column-headings">
          <strong>{{columnLabel}}</strong>
        </div>
      </ng-container>
      <ng-template #noDynamicColumns>
        <div class="mb-no-dynamic-col-width pl-3 mb-dynamic-column-headings"></div>
      </ng-template>
      <div class="mb-product-line-header-quantity"
           [ngClass]="[(hasDynamicColumns$ | async) ? 'mb-product-quantity-column-width pl-3' : (showWishList$ | async) ? 'col-2 pl-4' : 'mb-two-and-half-column-width pl-md-0 pl-lg-4']">
        <strong [innerHTML]="'pdpProductLine.quantity' | mbTranslate"></strong>
      </div>
      <div class="text-left"
           [ngClass]="[(hasDynamicColumns$ | async) ? 'mb-one-and-half-column-width pl-3 ' : (showWishList$ | async) ? 'col-2 pl-4' : 'mb-two-and-half-column-width pl-md-3 pl-lg-4']">
        <strong [innerHTML]="'pdpProductLine.listPrice' | mbTranslate"></strong>
      </div>
      <div
        [ngClass]="[(hasDynamicColumns$ | async) ? 'mb-add-to-cart-button-column-width pl-3' : !(showWishList$ | async) ? 'col pl-4 pr-3 pl-md-3 pl-lg-4 pl-xl-4 pr-lg-3' : 'mb-add-to-cart-no-dynamic-wishlist-column-width pl-3']"></div>
      <div *ngIf="showWishList$ | async" class="mb-half-column-width pl-3"></div>
    </div>

    <ng-container *ngFor="let variantOption of variantOptionsToDisplay">
      <mb-product-line [productLine]="variantOption?.productLine"
                       [dataAnalyticsClickSource]="dataAnalyticsClickSource"
                       [showDynamicColumns]="hasDynamicColumns$ | async"
                       [isWishListShown]="showWishList$ | async">
      </mb-product-line>
    </ng-container>

    <ng-container *ngIf="otherSizesOfVariants$ | async as otherSizesOfVariants">
      <ng-container *ngIf="otherSizesOfVariants?.length">
        <div class="row no-gutters mb-other-sizes"
             data-cy="mb-other-sizes">
          <div class="col-12 mb-other-sizes-divider mt-2" data-cy="mb-other-sizes-divider"></div>
          <div class="col-12 text-center mb-other-sizes-text"
               data-cy="mb-other-sizes-text">
            <span class="px-2" [innerHTML]="'pdpProductLine.otherSizes' | mbTranslate"></span>
          </div>
        </div>

        <ng-container *ngFor="let otherSizeVariantOption of otherSizesOfVariants; index as i">
          <mb-product-line [productLine]="otherSizeVariantOption?.productLine"
                           [dataAnalyticsClickSource]="dataAnalyticsClickSource"
                           [showDynamicColumns]="hasDynamicColumns$ | async"
                           [isWishListShown]="showWishList$ | async"
                           [attr.data-cy]="'mb-other-sizes-item-' + i">
          </mb-product-line>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

